import styled, { keyframes } from 'styled-components';
import DoodleImage from '../../images/doodle.svg';
import * as palette from '../../styles/variables';

const forwardAnimation = keyframes`
  from { transform: translateY(-220px); }
  to { transform: translateY(0px); }
 `;

const fadeTitle = keyframes` 
  from {
    overflow: hidden;
    transform:translate(0, 100px);

  }
  to { 
    overflow: visible;
  }
`;

const fadeTempTitle = keyframes` 
  from {
    overflow: hidden;
    transform:translate(0, 180px);

  }
  to {
    overflow: visible;
  }
`;

export const Container = styled.div`
  width: 95%;
  height: 100%;
  margin-left: 5%;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  font-family: Montserrat, sans-serif;
  justify-content: space-between;
  background: #f5f5f5;
  padding: 2%;
  position: relative;
  @media (max-width: 386px) {
    margin-top: 25%;
    margin-left: 0;
    width: 100%;
  }
`;

export const TitleSection = styled.div`
  width: 100%;
  height: 20%;
  background: #ffde59 !important;
  display: flex;
  position: relative;
  flex-direction: column;
  padding-left: 50px;
  border-radius: 20px;
  overflow: hidden;
`;

export const Title = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  align-items: flex-start;
  justify-content: center;
  height: 100%;
  animation: ${fadeTitle} 1s ease-in-out 0s backwards;
  animation: ${fadeTempTitle} 1s ease-in-out 0s backwards !important;
  h3 {
    letter-spacing: 1.5px;
    font-size: 46px;
    font-weight: 400;
    font-family: ${palette.FONT_FAMILY_TEMPLATE};
    color: #000;
    margin-bottom: 15px;
    text-transform: capitalize;
  }
  h6 {
    color: #000 !important;
    font-size: 14px;
    letter-spacing: 1px;
    text-transform: uppercase;
    font-weight: 400;
  }
`;

export const Doodle = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  transform: translateY(-460px);
  background: url(${DoodleImage}) 0% 0% / 550px 550px repeat;
  opacity: 0.25;
  animation-name: ${forwardAnimation};
  animation-delay: 0s;
  animation-duration: 60s;
  animation-fill-mode: forwards;
  animation-play-state: running;
  animation-iteration-count: infinite;
`;

export const SelectedPlan = styled.div`
  width: 30%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background: #4c327b;
  border-radius: 35px;
  padding: 10px 25px;
  position: absolute;
  top: 19%;
  right: 5%;
  z-index: 100;
  @media (max-width: 1256px) {
    top: 19%;
    width: 40%;
  }
  @media (max-width: 768px) {
    width: 50%;
  }
  @media (max-width: 426px) {
    width: 90% !important;
  }
  @media (min-width: 1946px) {
    width: 22%;
    padding: 14px 25px;
    top: 19.5%;
  }
  .ant-btn {
    background: #000 !important;
    border: transparent;
    border-radius: 12px;
    color: #fff;
    text-transform: uppercase;
    font-size: 11px;
    font-weight: 700;
  }
`;

export const PlanDetail = styled.div`
  display: flex;
  flex-direction: column;
  text-transform: uppercase;
  width: 55%;
  @media (max-width: 1256px) {
    width: 50%;
  }
  .currentPlan {
    color: #fff;
    font-weight: 700;
    font-size: 14px;
    @media (max-width: 1256px) {
      font-size: 11px;
    }
    @media (max-width: 768px) {
      font-size: 10px;
    }
    @media (max-width: 426px) {
      font-size: 9px !important;
    }
  }
  .renewal {
    color: #ffde59;
    font-size: 13px;
    @media (max-width: 1256px) {
      font-size: 11px;
    }
    @media (max-width: 768px) {
      font-size: 10px;
    }
    @media (max-width: 426px) {
      font-size: 9px !important;
    }
  }
`;

export const UsageDetailsWithNotes = styled.div`
  width: 100%;
  height: 78%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff;
  border-radius: 20px;
  z-index: 1;
  box-shadow: rgba(17, 17, 26, 0.1) 0px 0px 16px;
  justify-content: space-between;
  padding: 0 50px;
  @media (max-height: 700px) {
    overflow-y: scroll;
  }
  @media (max-width: 768px) {
    overflow: hidden;
    overflow-y: auto;
    padding: 40px 50px;
  }
  @media (max-width: 426px) {
    padding: 40px 0;
  }
`;

export const UsageDetails = styled.div`
  width: 100%;
  height: 90%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media (max-height: 700px) {
    height: auto;
  }
  .transactions-info {
    padding: 28px;
    width: 28%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 50px;
    @media (max-width: 1460px) {
      gap: 25px;
    }
    @media (max-width: 768px) {
      width: 100%;
    }
  }
  @media (max-width: 768px) {
    flex-direction: column;
    height: fit-content;
  }
`;

export const DocAutomationSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px 0px;
  justify-content: space-between;
  padding: 25px;
  height: 50%;
  background: ${props => props.isEmail ? 'linear-gradient(to left, rgb(49, 145, 151), rgb(175, 0, 45) 41.07%, rgb(255, 122, 24) 76.05%) !important;': 'linear-gradient(to right, #69006a, #050a84) !important'};
  border-radius: 40px;
  h4 {
    text-align: left;
    width: 100%;
    text-transform: uppercase;
    font-size: 14px;
    font-weight: 600;
    color: #fff;
    margin-bottom: 15px;
    @media (max-width: 1460px) {
      font-size: 12px;
    }
    @media (max-width: 1256px) {
      font-size: 11px;
      margin-bottom: 25px;
    }
  }
  .generateDocValue {
    display: flex;
    align-items: center;
    width: 90%;
    flex-direction: row;
    height: 85%;
    gap: 15px;
  }
  .ant-progress {
    width: 60% !important;
    text-align: center;
  }
  .ant-progress-circle-trail {
    stroke: #fff !important;
    /* stroke-width: 30px !important; */
  }
  .ant-progress-circle .ant-progress-text {
    color: #fff;
    font-size: 25px;
    font-weight: 900;
    @media (max-width: 1460px) {
      font-size: 18px;
    }
  }
  .ant-progress-circle .ant-progress-inner {
    width: 150px !important;
    height: 150px !important;
    @media (max-width: 1460px) {
      width: 125px !important;
      height: 125px !important;
    }
    @media (max-width: 1256px) {
      width: 110px !important;
      height: 110px !important;
    }
  }
  .ant-progress-inner:not(.ant-progress-circle-gradient) .ant-progress-circle-path {
    stroke: #41b8d5 !important;
    /* stroke-width: 30px; */
  }
  h5 {
    color: #fff;
    text-transform: uppercase;
    font-size: 14px;
    @media (max-width: 1460px) {
      font-size: 12px;
    }
    @media (max-width: 1256px) {
      font-size: 10px;
    }
  }
  p {
    font-size: 15px;
    line-height: 1.5;
    color: #ffeb3b;
    text-transform: uppercase;
    text-align: center;
    @media (max-width: 1460px) {
      font-size: 12px;
    }
    @media (max-width: 1256px) {
      font-size: 10px;
    }
  }
`;

export const AccountPlanUsage = styled.div`
  width: 68% !important;
  text-align: center;
  height: 75%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  @media (min-height: 700px) and (max-height: 800px) {
    padding-inline: 12px;
    overflow-y: scroll;
  }
  @media (max-width: 768px) {
    width: 100% !important;
    flex-direction: column;
    align-items: center;
    height: 100%;
    margin: 25px 0px;
  }
  .ant-slider {
    margin: 14px 6px 10px 0;
  }
  .ant-slider-disabled .ant-slider-track {
    position: absolute;
    height: 4px;
    background-color: #ffeb3b !important;
  }
  .ant-slider-disabled .ant-slider-handle,
  .ant-slider-disabled .ant-slider-dot {
    background-color: #4c327b !important;
    border-color: #4c327b !important;
    box-shadow: none;
  }
  .usageSection {
    width: 47%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .nonSliderVal {
      width: 65%;
      font-size: 13px;
      font-weight: 600;
      color: #000;
      text-align: right;
      margin-right: 10px;
    }
    @media (max-width: 768px) {
      width: 75%;
    }
    @media (max-width: 426px) {
      width: 80% !important;
    }
  }
  .branding {
    display: flex;
    width: 100%;
    height: 18%;
    align-items: center;
    @media (max-width: 768px) {
      margin-top: 25px;
    }
  }
`;

export const AvailValCol = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 40%;
`;

export const AvailableValue = styled.div`
  font-size: 11px;
  line-height: 25px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  background: #4c327b;
  color: #fff !important;
  max-width: 95%;
  min-width: 85%;
  margin-left: 10%;
  padding: 6px;
  border-radius: 25px;
  p {
    font-size: 13px;
    margin-right: 5px;
    line-height: 1.5;
    @media (max-width: 1460px) {
      font-size: 10px;
    }
    @media (max-width: 1256px) {
      font-size: 8px;
    }
  }
  .count {
    font-weight: 800;
  }
  .infinity-icon{
    display:inline-block;
    font-size:18px;
    line-height:0px;
  }
`;

export const UsedValue = styled.div`
  width: 100%;
  height: 75%;
  display: flex;
  align-items: center;
  .ant-slider-disabled {
    cursor: auto !important;
    width: 60%;
  }
  .ant-slider-disabled .ant-slider-handle {
    cursor: auto !important;
  }
`;

export const PlanOption = styled.div`
  text-transform: uppercase;
  font-size: 13px;
  font-weight: 600;
  color: #545454;
  text-align: left;
  height: 25%;
  width: 100%;
  letter-spacing: 1px;
  span {
    margin-left: 5px;
    color: #000;
    text-transform: initial;
    font-weight: 600;
    line-height: 4 !important;
    @media (max-width: 1256px) {
      line-height: normal !important;
    }
  }
  i.anticon.anticon-warning {
    font-size: 18px;
    margin-left: 5px;
    color: #ff0000;
    animation: blinker 2s linear infinite;
    @keyframes blinker {
      50% {
        opacity: 0;
      }
    }
  }
`;

export const KeyNote = styled.div`
  width: 55%;
  height: 15%;
  text-align: center;
  font-size: 13px;
  color: #000;
  span {
    color: #ff0000;
  }
  @media (max-width: 1256px) {
    font-size: 11px;
  }
  @media (max-width: 768px) {
    font-size: 10px;
    height: fit-content;
  }
`;

export const GenerateDocumentCount = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  flex-direction: column;
  height: 100%;
  width: 40%;
  gap: 12px;
  .pagesCount {
    font-weight: 600;
  }
`;
